module.exports = __webpack_public_path__ + "img/handshake.5764b5ee.svg";